<div class="title-bar mat-headline-5">
  {{ celebrationConfig.title }}

  <span matSnackBarActions
        class="dismiss-action">
    <button mat-icon-button
            matSnackBarAction
            (click)="snackBarRef.dismissWithAction()">
      <mat-icon>close</mat-icon>
    </button>
  </span>
</div>

<div class="row message-bar">
  {{ celebrationConfig.message }}
  <img [ngSrc]="starImage"
       width="48"
       height="48"
       alt="star">
</div>